export const IS_OPENED = 1;
export const IS_CLOSE_APPROVED = 4;
export const IS_CLOSED = 3;

export const TabMapper = {
    1: 'is_opened',
    4: 'is_close_approved',
}